/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update a claim photo's metadata.
 * @export
 * @interface UpdateClaimPhotoRequest
 */
export interface UpdateClaimPhotoRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPhotoRequest
     */
    filename?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimPhotoRequest
     */
    caption?: string | null;
}

/**
 * Check if a given object implements the UpdateClaimPhotoRequest interface.
 */
export function instanceOfUpdateClaimPhotoRequest(value: object): value is UpdateClaimPhotoRequest {
    return true;
}

export function UpdateClaimPhotoRequestFromJSON(json: any): UpdateClaimPhotoRequest {
    return UpdateClaimPhotoRequestFromJSONTyped(json, false);
}

export function UpdateClaimPhotoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimPhotoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'filename': json['filename'] == null ? undefined : json['filename'],
        'caption': json['caption'] == null ? undefined : json['caption'],
    };
}

export function UpdateClaimPhotoRequestToJSON(json: any): UpdateClaimPhotoRequest {
    return UpdateClaimPhotoRequestToJSONTyped(json, false);
}

export function UpdateClaimPhotoRequestToJSONTyped(value?: UpdateClaimPhotoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filename': value['filename'],
        'caption': value['caption'],
    };
}

